import React from 'react'
import {uploadFormComponents} from '@modifi/plugin-documents'
import {useTranslation} from '@modifi/plugin-i18n'
import {Row, Col, Small} from '@modifi/ui'
import styled from 'styled-components'

const SmallBlock = styled(Small)`
  display: block;
`

const DocumentTypeRowWrapper = styled.div`
  h6 {
    margin-left: 0;
  }
`

type DocumentTypeRowWithDescriptionProps = {
  innerRef?: React.Ref<any>
  documentType: string
} & Record<string, any>

const DocumentTypeRowWithDescription: React.FC<DocumentTypeRowWithDescriptionProps> = ({
  innerRef,
  documentType,
  ...props
}) => {
  const {t} = useTranslation('charon')
  return (
    <>
      <DocumentTypeRowWrapper>
        <uploadFormComponents.DocumentTypeRow
          ref={innerRef}
          // @ts-expect-error the documents plugin does not expose the row props
          documentType={documentType}
          {...props}
        />
      </DocumentTypeRowWrapper>
      <Row>
        <Col col={12} mb={8} mt={8}>
          <SmallBlock>{t(`trade-parter.document-upload.${documentType}.description`)}</SmallBlock>
        </Col>
      </Row>
    </>
  )
}

export default React.forwardRef<any, DocumentTypeRowWithDescriptionProps>((props, ref) => (
  // @ts-expect-error to be fixed
  <DocumentTypeRowWithDescription {...props} innerRef={ref} />
))
